<template>
  <div style="margin-top:15px;padding:0px 20px;">
    <div class="mode_box">
      <el-form ref="formData" class="form_all_box" :model="form" :rules="rules">
        <el-form-item label="承运主体" prop="branchCode" class="form_item_box">
          <el-select
            v-model="form.branchCode"
            :disabled="true"
            placeholder="请选择承运主体"
          >
            <el-option
              v-for="item in partyGroupOptions"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="服务费率(%)" prop="taxPoint" class="form_item_box">
          <el-input
            v-model="form.taxPoint"
            type="number"
            min="0"
            max="100"
            placeholder="请输入服务费(%)"
          />
        </el-form-item>
        <!-- 油气服务优惠 -->
        <el-form-item
          label="油气优惠比例(%)"
          prop="discountPoint"
          class="form_item_box"
        >
          <el-input
            v-model="form.discountPoint"
            placeholder="请输入油气优惠比例(%)"
            @input="handleOilGasStandardInput"
          />
        </el-form-item>
        <!-- 生效时间 -->
        <!-- -->
        <el-form-item label="生效时间" prop="executeTime" class="form_item_box">
          <!-- 年月日时分秒  -->
          <el-date-picker
            v-model="form.executeTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择生效时间"
            style="width: 100%;"
            :picker-options="executeTimePickerOptions"
            @visible-change="onExecuteTimePickerVisible"
          />
        </el-form-item>

        <!-- <el-form-item label="调度费率(%)" prop="dispatchPoint" class="form_item_box">
          <el-input
            v-model="form.dispatchPoint"
            type="number"
            min="0"
            max="100"
            placeholder="请输入调度费率(%)"
          />
        </el-form-item>

        <el-form-item v-if="form.dispatchPoint > 0" label="运费计算规则" prop="taxPoint" class="form_item_box">
          <el-select
            v-model="form.freightRoundingType"
            placeholder="请选择"
            @change="changeFreightRoundingType"
          >
            <el-option
              v-for="item in optionsfreightRoundingType"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div style="text-align:right;margin-top:40px;margin-bottom:20px;">
      <el-button @click="clsoeModel">取消</el-button>
      <el-button type="primary" @click="updateTax">确认修改</el-button>
    </div>
  </div>
</template>
<script>
import { updateTaxFee } from "@/api/shipment";
import request from "@/utils/request";
export default {
  props: {
    branchInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      /** 可选生效时间下限：打开面板时为「此刻 + 5 分钟」 */
      executeTimePickerMin: new Date(Date.now() + 5 * 60 * 1000),
      optionsfreightRoundingType: [
        {
          code: 0,
          name: "保留小数"
        },
        {
          code: 1,
          name: "抹除小数"
        },
        {
          code: 2,
          name: "抹除个位"
        },
        {
          code: 3,
          name: "抹除十位"
        },
        {
          code: 4,
          name: "向下取整到5的倍数"
        }
      ],
      partyGroupOptions: [],
      form: {
        branchCode: "",
        taxPoint: null,
        dispatchPoint: null,
        freightRoundingType: 0,
        executeTime: null,
        discountPoint: ""
      },
      rules: {
        executeTime: [
          { required: true, message: "请选择生效时间", trigger: "blur" }
        ],
        branchCode: [
          { required: true, message: "请选择承运主体", trigger: "change" }
        ],
        taxPoint: [
          { required: true, message: "请输入服务费率", trigger: "blur" },
          {
            type: "number",
            message: "服务费率必须为数字",
            trigger: "blur",
            transform: value => Number(value)
          }
        ]
      }
    };
  },
  computed: {
    executeTimePickerOptions() {
      const min = this.executeTimePickerMin;
      const pad = n => String(n).padStart(2, "0");
      const hms = d =>
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      const minDayStart = new Date(
        min.getFullYear(),
        min.getMonth(),
        min.getDate()
      ).getTime();

      let selectableRange = `${hms(min)} - 23:59:59`;
      const raw = this.form.executeTime;
      if (raw) {
        const sel = new Date(String(raw).replace(/-/g, "/"));
        if (!isNaN(sel.getTime())) {
          const selDay = new Date(
            sel.getFullYear(),
            sel.getMonth(),
            sel.getDate()
          ).getTime();
          if (selDay > minDayStart) {
            selectableRange = "00:00:00 - 23:59:59";
          }
        }
      }

      return {
        disabledDate(time) {
          const dayStart = new Date(
            time.getFullYear(),
            time.getMonth(),
            time.getDate()
          ).getTime();
          return dayStart < minDayStart;
        },
        selectableRange
      };
    }
  },
  watch: {
    branchInfo: {
      handler(newVal) {
        if (newVal) {
          this.form.id = newVal.id;
          this.form.partyCode = newVal.partyCode;
          this.form.branchCode = newVal.branchCode;
          this.form.taxPoint = +newVal.taxPoint;
          this.form.dispatchPoint = +newVal.dispatchPoint;
          this.form.freightRoundingType = +newVal.freightRoundingType;
          this.form.executeTime = newVal.executeTime;
          this.form.discountPoint = newVal.discountPoint;
          console.log("传递的信息=========", newVal);
          this.getBranchList(newVal.branchCode);
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  methods: {
    /** 油气优惠比例：仅允许数字，最多两位小数 */
    handleOilGasStandardInput(val) {
      if (val === "" || val === null || val === undefined) {
        this.form.discountPoint = "";
        return;
      }
      let v = String(val).replace(/[^\d.]/g, "");
      const dot = v.indexOf(".");
      if (dot !== -1) {
        v =
          v.slice(0, dot + 1) +
          v
            .slice(dot + 1)
            .replace(/\./g, "")
            .slice(0, 2);
      }
      this.form.discountPoint = v;
    },
    onExecuteTimePickerVisible(visible) {
      if (visible) {
        this.executeTimePickerMin = new Date(Date.now() + 5 * 60 * 1000);
      }
    },

    changeFreightRoundingType(e) {
      this.form.freightRoundingType = e;
    },
    async updateTax() {
      if (+this.form.taxPoint === 0) {
        this.$message.error("服务费率必须大于0");
        return;
      }
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let res = await updateTaxFee(this.form);
          if (res.status === 0) {
            this.$message.success("修改成功");
            this.$emit("updateList");
          }
        }
      });
    },
    clsoeModel() {
      this.$emit("clsoeModel");
    },
    getBranchList() {
      request({
        url: "/ntocc-basic-api/partyGroup",
        method: "get"
      }).then(res => {
        if (res.status === 0) {
          console.log(this.partyGroupOptions);
          this.partyGroupOptions = res.data.records;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form_item_box {
  margin-bottom: 8px !important;
}
</style>
